import React, { useState } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { CreateRequeteDialog } from './CreateRequeteDialog';
import { SearchIcon, FilterIcon, MapPinIcon, MapIcon, TableIcon, FolderIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsUpDownIcon, PlusIcon, SettingsIcon, XIcon, PaperclipIcon, CheckSquareIcon, SquareIcon, LinkIcon, TagIcon, FileTextIcon, PrinterIcon, SendIcon, LockIcon, BellIcon, CheckIcon } from 'lucide-react';
type ViewMode = 'list' | 'map';
/** Citizen-facing tabs on the left pane. */
type LeftTab = 'infos' | 'messages';
/** Internal tabs on the right pane. */
type RightTab = 'gestion' | 'collaboration' | 'historique';
type Status = 'Nouvelle demande' | 'En Cours' | 'Complété' | 'En Attente' | 'Reçue';
interface Request {
  id: string;
  subject: string;
  category: string;
  reqId: string;
  location: string;
  date: string;
  status: Status;
  department: string;
  requester: {
    name: string;
    initials: string;
    color: string;
  };
  slaDate: string;
}
const MOCK_REQUESTS: Request[] = [{
  id: '1',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-101',
  location: '1520, 1 ère Rue, Richelieu,...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '2',
  subject: 'Bâtiment',
  category: 'Bâtiment',
  reqId: 'R-100',
  location: '205, Avenue 8e, Richelie...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '8 juillet 2026'
}, {
  id: '3',
  subject: 'Nid-de-poule - trait...',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-99',
  location: '2907, Rang de la Savane, ...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Caroline Nadeau',
    initials: 'CN',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '4',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-98',
  location: '32, Place Rouville-Tessier,...',
  date: '8 juin 2026',
  status: 'Complété',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '5',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-97',
  location: '700, Rue Martel, Richelie...',
  date: '4 juin 2026',
  status: 'En Cours',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '9 juin 2026'
}, {
  id: '6',
  subject: 'Plateaux sportifs - t...',
  category: 'Parcs et espaces récréatifs',
  reqId: 'R-96',
  location: '900, Rue des Oblats, Ric...',
  date: '3 juin 2026',
  status: 'Complété',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '8 juin 2026'
}, {
  id: '7',
  subject: 'Refoulement égout...',
  category: 'Eau potable et égout',
  reqId: 'R-95',
  location: '192, Rue des Érables, Ric...',
  date: '3 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Éric Robin',
    initials: 'ÉR',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '4 juin 2026'
}];
const getStatusColor = (status: Status) => {
  switch (status) {
    case 'Nouvelle demande':
      return 'bg-slate-200 text-slate-700';
    case 'En Cours':
      return 'bg-indigo-100 text-indigo-700';
    case 'Complété':
      return 'bg-indigo-100 text-indigo-700';
    case 'En Attente':
      return 'bg-orange-100 text-orange-700';
    case 'Reçue':
      return 'bg-slate-100 text-slate-600';
    default:
      return 'bg-slate-100 text-slate-700';
  }
};
const getStatusDot = (status: Status) => {
  switch (status) {
    case 'Nouvelle demande':
      return 'bg-slate-400';
    case 'En Cours':
      return 'bg-[#4F46E5]';
    case 'Complété':
      return 'bg-[#4F46E5]';
    case 'En Attente':
      return 'bg-orange-500';
    case 'Reçue':
      return 'bg-slate-400';
    default:
      return 'bg-slate-400';
  }
};
// Request locations around Windsor, QC
const MAP_MARKERS: {
  reqId: string;
  subject: string;
  category: string;
  position: [number, number];
}[] = [{
  reqId: 'R-127',
  subject: 'Taxation',
  category: 'Administration',
  position: [45.4528, -73.4622]
}, {
  reqId: 'R-104',
  subject: 'Lampadaire défectueux',
  category: 'Éclairage public',
  position: [45.4468, -73.4698]
}, {
  reqId: 'R-70',
  subject: 'Eau potable (qualité)',
  category: 'Eau potable et égout',
  position: [45.4552, -73.4578]
}, {
  reqId: 'R-103',
  subject: 'Feux de circulation',
  category: 'Éclairage public',
  position: [45.4438, -73.4728]
}, {
  reqId: 'R-57',
  subject: 'Lampadaire défectueux',
  category: 'Éclairage public',
  position: [45.4488, -73.4548]
}];
// Custom indigo map marker
const requestMarkerIcon = L.divIcon({
  className: '',
  html: `<div style="display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:9999px;background:#4F46E5;box-shadow:0 2px 6px rgba(0,0,0,0.3);border:2px solid white;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/></svg></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -14]
});
export function RequetesGerer() {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [leftTab, setLeftTab] = useState<LeftTab>('infos');
  const [rightTab, setRightTab] = useState<RightTab>('gestion');
  const [draft, setDraft] = useState('');
  const [noteDraft, setNoteDraft] = useState('');
  if (selectedRequest) {
    return <div className="bg-slate-50 -mx-4 sm:-mx-6 lg:-mx-8 -my-8 min-h-screen flex" data-id="element-5291" data-mp="34zy68l9cga3i">
        {/* Left Pane - Citizen Visible */}
        <div className="w-1/2 border-r border-slate-200 bg-white flex flex-col" data-id="element-5292" data-mp="1anrjcp7384vd">
          <div className="p-4 border-b border-slate-200 flex items-center gap-2 text-slate-500 text-sm font-medium" data-id="element-5293" data-mp="1apuhjwie94b6">
            <div className="w-4 h-4 rounded-full border-2 border-slate-300 flex items-center justify-center" data-id="element-5294" data-mp="ye1wjburgkjy">
              <div className="w-1.5 h-1.5 bg-slate-300 rounded-full" data-id="element-5295" data-mp="te5pf3qrod06"></div>
            </div>
            Visible par le citoyen
          </div>

          <div className="px-6 pt-4 border-b border-slate-200 flex gap-6" data-id="element-5296" data-mp="ohfeeuttk7lm">
            <button onClick={() => setLeftTab('infos')} className={`pb-3 border-b-2 font-semibold text-sm transition-colors ${leftTab === 'infos' ? 'border-[#4F46E5] text-[#4F46E5]' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-5297" data-mp="1m21mwao5u8y0">
              Infos
            </button>
            <button onClick={() => setLeftTab('messages')} className={`pb-3 border-b-2 font-semibold text-sm transition-colors flex items-center gap-2 ${leftTab === 'messages' ? 'border-[#4F46E5] text-[#4F46E5]' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-5298" data-mp="r2usmp7omf7">
              Messages
              <span className="px-1.5 py-0.5 rounded-full bg-[#4F46E5] text-white text-[10px] font-bold" data-id="element-5299" data-mp="cfpfft3junym">
                1
              </span>
            </button>
          </div>

          {leftTab === 'messages' && <>
              <div className="p-6 overflow-y-auto flex-1 space-y-5" data-id="element-5300" data-mp="147wmq2x60o0c">
                <div className="flex items-center gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2" data-id="element-5301" data-mp="1945a23linnil">
                  <BellIcon className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" data-id="element-5302" data-mp="zeu0ygymqiup" />
                  Nathalie Ouellet reçoit chaque message par courriel et
                  notification bciti+.
                </div>

                <div className="text-center" data-id="element-5303" data-mp="1rvob44vzcrhz">
                  <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-5304" data-mp="1rwft2cwnmqps">
                    19 mai 2026
                  </span>
                </div>

                {/* Citizen message */}
                <div className="flex gap-3" data-id="element-5305" data-mp="37kmemcurxl32">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0" data-id="element-5306" data-mp="3mabjai22s783">
                    NO
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5307" data-mp="2tlw9c9xswf3m">
                    <div className="bg-slate-50 border border-slate-200 rounded-xl rounded-tl-sm p-3.5 text-sm text-slate-700 leading-relaxed" data-id="element-5308" data-mp="2tos820hh37t4">
                      Bonjour, je voulais savoir si quelqu'un est passé au parc.
                      Les branches sont toujours sur le sentier ce matin et les
                      enfants passent par là pour aller à l'école.
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-5309" data-mp="iwqwj1sfy1u7">
                      Nathalie Ouellet · 19 mai, 08:12
                    </div>
                  </div>
                </div>

                {/* Staff reply */}
                <div className="flex gap-3 flex-row-reverse" data-id="element-5310" data-mp="2v5w14qg5xe77">
                  <div className="w-8 h-8 rounded-full bg-slate-800 text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" data-id="element-5311" data-mp="2v8iitiwrpa35">
                    JD
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5312" data-mp="2lei891ipvcn1">
                    <div className="bg-[#4F46E5] rounded-xl rounded-tr-sm p-3.5 text-sm text-white leading-relaxed" data-id="element-5313" data-mp="2ghrpu7jfw4yg">
                      Bonjour Mme Ouellet, merci pour votre signalement. Une
                      équipe des Travaux publics est planifiée pour le
                      ramassage des branches le 21 mai en avant-midi. Les
                      poubelles ont été vidées hier.
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1 text-right flex items-center justify-end gap-1.5" data-id="element-5314" data-mp="5o5h1bgpl1xz">
                      Jacques Dubois · 19 mai, 09:47
                      <CheckIcon className="w-3 h-3 text-emerald-500" data-id="element-5315" data-mp="8aftkee62fl5" />
                      <span className="text-emerald-600 font-medium" data-id="element-5316" data-mp="d8zkkt7mahkd">Lu</span>
                    </div>
                  </div>
                </div>

                <div className="text-center" data-id="element-5317" data-mp="i10rdzm0ng30">
                  <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider" data-id="element-5318" data-mp="i226cf65kmq0">
                    20 mai 2026
                  </span>
                </div>

                {/* Automated status message */}
                <div className="flex gap-3" data-id="element-5319" data-mp="3qepv170h0i7n">
                  <div className="w-8 h-8 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-5320" data-mp="3qfrfu37agj2k">
                    <BellIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5321" data-mp="48ub8div593k" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5322" data-mp="1aon4byh4vx2j">
                    <div className="bg-white border border-dashed border-slate-300 rounded-xl p-3.5 text-sm text-slate-600 leading-relaxed" data-id="element-5323" data-mp="1anvdf0yhenil">
                      <span className="font-semibold text-slate-700" data-id="element-5324" data-mp="3bqcl2ihyjcm8">
                        Mise à jour automatique
                      </span>
                      <br data-id="element-5325" data-mp="36r0063ancfma" />
                      Le statut de votre requête est passé à « En cours ».
                      Échéance prévue : 26 mai 2026.
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-5326" data-mp="3gqqv2634cwmw">
                      Envoyé automatiquement · 20 mai, 07:00
                    </div>
                  </div>
                </div>

                {/* Latest citizen message, unanswered */}
                <div className="flex gap-3" data-id="element-5327" data-mp="31sf0c4zb3xyd">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0" data-id="element-5328" data-mp="31t89tdpnh1k7">
                    NO
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-5329" data-mp="29b2mx0gvmato">
                    <div className="bg-slate-50 border border-slate-200 rounded-xl rounded-tl-sm p-3.5 text-sm text-slate-700 leading-relaxed" data-id="element-5330" data-mp="299rlh7awlf5q">
                      Parfait, merci beaucoup pour le suivi rapide !
                    </div>
                    <div className="text-[11px] text-slate-400 mt-1" data-id="element-5331" data-mp="1zxkf63rvqcui">
                      Nathalie Ouellet · 20 mai, 11:23 ·{' '}
                      <span className="text-[#4F46E5] font-medium" data-id="element-5332" data-mp="1la92fyjyomst">
                        Sans réponse
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Composer */}
              <div className="border-t border-slate-200 p-4 bg-white" data-id="element-5333" data-mp="2iwpvuspkqg9a">
                <textarea value={draft} onChange={e => setDraft(e.target.value)} rows={3} placeholder="Écrire au citoyen..." className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5334" data-mp="23yxj28bew5ys" />
                <div className="flex items-center justify-between mt-2.5" data-id="element-5335" data-mp="1dpzr4tcyfzhl">
                  <div className="flex items-center gap-1" data-id="element-5336" data-mp="1dravove85b9r">
                    <button aria-label="Joindre un fichier" className="p-2 rounded-lg text-slate-400 hover:text-[#4F46E5] hover:bg-indigo-50 transition-colors" data-id="element-5337" data-mp="18yzxpy31nzju">
                      <PaperclipIcon className="w-4 h-4" data-id="element-5338" data-mp="z2n4107i1lp3" />
                    </button>
                    <span className="text-xs text-slate-400" data-id="element-5339" data-mp="1wnj58be9s8av">
                      Visible par le citoyen
                    </span>
                  </div>
                  <button disabled={!draft.trim()} onClick={() => setDraft('')} className="inline-flex items-center gap-2 px-4 py-2 bg-[#4F46E5] text-white text-sm font-semibold rounded-lg hover:bg-[#4338CA] disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-5340" data-mp="1mqedzx5khmn7">
                    <SendIcon className="w-4 h-4" data-id="element-5341" data-mp="6b3dswchj7dl" />
                    Envoyer
                  </button>
                </div>
              </div>
            </>}

          <div className={`p-6 overflow-y-auto flex-1 ${leftTab === 'infos' ? '' : 'hidden'}`} data-id="element-5342" data-mp="2mzwa7vjk0tx6">
            <div className="flex justify-between items-start mb-8" data-id="element-5343" data-mp="2rwcyqquo1aas">
              <div className="flex gap-4" data-id="element-5344" data-mp="2woxmpbqw4t6e">
                <div className="w-12 h-12 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-5345" data-mp="2wpz3lwul89w1">
                  <FolderIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-5346" data-mp="35p2nh31kwtbl" />
                </div>
                <div data-id="element-5347" data-mp="3aoff013eaoki">
                  <div className="flex items-center gap-2" data-id="element-5348" data-mp="3ao5psfq6clfv">
                    <h2 className="text-xl font-bold text-slate-900" data-id="element-5349" data-mp="3ammb2tk62ig7">
                      Entretien des parcs
                    </h2>
                    <ChevronLeftIcon className="w-4 h-4 text-slate-400 rotate-[-90deg]" data-id="element-5350" data-mp="1gb7je77li8xt" />
                  </div>
                  <div className="text-sm text-slate-500 mt-1 flex items-center gap-2" data-id="element-5351" data-mp="1lak3ik7311wp">
                    <span className="bg-slate-100 px-2 py-0.5 rounded text-xs font-medium border border-slate-200" data-id="element-5352" data-mp="1d81ff33jc3wi">
                      R-71
                    </span>
                    <span data-id="element-5353" data-mp="1n6zaypzdoxp0">Parcs et espaces récréatifs</span>
                  </div>
                  <div className="text-sm text-slate-400 mt-1 ml-10 border-l-2 border-slate-200 pl-2" data-id="element-5354" data-mp="1n4mj9l3tj8yr">
                    Service Des Travaux Publics
                  </div>
                </div>
              </div>
              <div className={`px-3 py-1 rounded-full text-sm font-medium flex items-center gap-2 ${getStatusColor('En Cours')}`} data-id="element-5355" data-mp="1s624bd5zxfh5">
                <div className={`w-2 h-2 rounded-full ${getStatusDot('En Cours')}`} data-id="element-5356" data-mp="25wp478nhtbet"></div>
                En Cours
              </div>
            </div>

            <div className="mb-8" data-id="element-5357" data-mp="2fwfwr4shtgc9">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5358" data-mp="2fta79ofyccg0">
                DESCRIPTION
              </h3>
              <div className="p-4 rounded-xl border border-slate-200 bg-white text-slate-700 text-sm leading-relaxed" data-id="element-5359" data-mp="2ui3i2tafmqwp">
                Le parc près de la rue Principale nécessite un entretien urgent.
                Les poubelles débordent et il y a des branches cassées sur le
                sentier principal suite à la tempête d'hier soir. Cela
                représente un danger pour les piétons et les cyclistes.
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-5360" data-mp="2asjhg64i0ozr">
              <div data-id="element-5361" data-mp="2flvz1warfvj0">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5362" data-mp="2fn75k3vlbhdt">
                  DEMANDEUR
                </h3>
                <div className="flex items-start gap-3" data-id="element-5363" data-mp="26s9aaq4yzsjb">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-5364" data-mp="26qofr0ino9lg">
                    NO
                  </div>
                  <div data-id="element-5365" data-mp="1wwpd80eo6nsz">
                    <div className="font-semibold text-slate-900 text-sm" data-id="element-5366" data-mp="2cccmx4zgod9e">
                      Nathalie Ouellet
                    </div>
                    <div className="text-sm text-slate-500 mt-0.5" data-id="element-5367" data-mp="28cc99mk6s63e">
                      (450) 658-1157
                    </div>
                    <div className="text-sm text-slate-500" data-id="element-5368" data-mp="23e0x356f5ji0">
                      adjointe.tp@ville.richelieu.qc.ca
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-5369" data-mp="1tfl7j6n1iiam">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5370" data-mp="1ona5ny8qomff">
                  EMPLACEMENT
                </h3>
                <div className="flex items-start gap-2" data-id="element-5371" data-mp="1klydbkyhdn3j">
                  <MapPinIcon className="w-4 h-4 text-slate-400 mt-0.5 flex-shrink-0" data-id="element-5372" data-mp="1fmvkcyvrz7bx" />
                  <div data-id="element-5373" data-mp="1amzf6wbcd9us">
                    <div className="text-sm text-slate-700" data-id="element-5374" data-mp="1animlj3d8fuk">
                      200 Boulevard Richelieu
                    </div>
                    <div className="text-sm text-slate-700" data-id="element-5375" data-mp="15oxwwdlqpekd">
                      Richelieu, J3L 3R1
                    </div>
                    <button className="text-sm text-[#4F46E5] mt-1 hover:underline" data-id="element-5376" data-mp="vmlmi6lt54iy">
                      Voir sur la carte ▾
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div data-id="element-5377" data-mp="1ahrs4sgzr1br">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5378" data-mp="1ag6yr66exofh">
                PIÈCES JOINTES
              </h3>
              <div className="flex gap-3" data-id="element-5379" data-mp="hsu9go8vb2ih">
                <div className="w-20 h-20 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5380" data-mp="htvvtovc3bfi">
                  <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop" alt="Parc" className="w-full h-full object-cover" data-id="element-5381" data-mp="mrnmkfk8sri4" />
                </div>
                <div className="w-20 h-20 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5382" data-mp="3q6td8c22zs6j">
                  <img src="https://images.unsplash.com/photo-1519331379826-f10be5486c6f?w=200&h=200&fit=crop" alt="Parc" className="w-full h-full object-cover" data-id="element-5383" data-mp="3v5mixib4mew5" />
                </div>
                <button className="w-20 h-20 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" data-id="element-5384" data-mp="219wthwuogm8t">
                  <PlusIcon className="w-5 h-5 mb-1" data-id="element-5385" data-mp="18lr7l6rw0r7e" />
                  <span className="text-xs font-medium" data-id="element-5386" data-mp="1dirched03nwx">Téléverser</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Pane - Internal */}
        <div className="w-1/2 bg-slate-50 flex flex-col relative" data-id="element-5387" data-mp="1mc4d72hb3ttk">
          <button onClick={() => setSelectedRequest(null)} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-200 transition-colors z-10" data-id="element-5388" data-mp="1mdfgz2ar51ko">
            <XIcon className="w-5 h-5" data-id="element-5389" data-mp="mbipm2ijq3yr" />
          </button>

          <div className="p-4 border-b border-slate-200 flex items-center justify-between text-slate-500 text-sm font-medium bg-white" data-id="element-5390" data-mp="mazhtemm0vyg">
            <div className="flex items-center gap-2" data-id="element-5391" data-mp="daudjdcpqdoi">
              <div className="w-4 h-4 rounded flex items-center justify-center border-2 border-slate-300" data-id="element-5392" data-mp="d99h1i6u8ko0">
                <div className="w-2 h-2 bg-slate-300 rounded-sm" data-id="element-5393" data-mp="8bq0gbmo3vsw"></div>
              </div>
              Interne — non visible par le citoyen
            </div>
            <PrinterIcon className="w-4 h-4 mr-10" data-id="element-5394" data-mp="3urcasunto3m5" />
          </div>

          <div className="px-6 pt-4 border-b border-slate-200 flex gap-6 bg-white" data-id="element-5395" data-mp="3pshhuzw54yob">
            {[{
            id: 'gestion' as const,
            label: 'Gestion'
          }, {
            id: 'collaboration' as const,
            label: 'Collaboration'
          }, {
            id: 'historique' as const,
            label: 'Historique'
          }].map(tab => <button key={tab.id} onClick={() => setRightTab(tab.id)} className={`pb-3 border-b-2 font-semibold text-sm transition-colors ${rightTab === tab.id ? 'border-[#4F46E5] text-[#4F46E5]' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-5396" data-mp="3bti08c71pk1n">
                {tab.label}
              </button>)}
          </div>

          {rightTab === 'collaboration' && <div className="p-6 overflow-y-auto flex-1 space-y-6" data-id="element-5397" data-mp="3puoxff2d4ys1">
              <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5398" data-mp="3ptx1u48rn11r">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5399" data-mp="3b50y2jdqsa6y">
                  INTERVENANTS ASSIGNÉS
                </h3>
                <div className="space-y-3" data-id="element-5400" data-mp="7pbytws57xh6">
                  <div className="flex items-center justify-between" data-id="element-5401" data-mp="7oacux9l9qko">
                    <div className="flex items-center gap-3" data-id="element-5402" data-mp="cg23f7sqvwat">
                      <div className="w-8 h-8 rounded-full bg-slate-800 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5403" data-mp="chmzx2ymdpbb">
                        JD
                      </div>
                      <div data-id="element-5404" data-mp="1s5a17fjm9j7e">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-5405" data-mp="26wilra8nwedo">
                          Jacques Dubois
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5406" data-mp="21xpisbr045rr">
                          Travaux publics · Responsable
                        </div>
                      </div>
                    </div>
                    <span className="text-xs font-medium text-emerald-700 bg-emerald-50 px-2 py-1 rounded border border-emerald-100" data-id="element-5407" data-mp="19a33w7cbpepl">
                      Actif
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-5408" data-mp="1j8iu883j0jy1">
                    <div className="flex items-center gap-3" data-id="element-5409" data-mp="2yllqer4gnqqu">
                      <div className="w-8 h-8 rounded-full bg-amber-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5410" data-mp="2um4m410rszn9">
                        MG
                      </div>
                      <div data-id="element-5411" data-mp="3twtn3amemrfq">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-5412" data-mp="3ty4r9bjri17d">
                          Martin Gauthier
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5413" data-mp="7q5544jwm154">
                          Parcs et espaces verts · Exécutant
                        </div>
                      </div>
                    </div>
                    <span className="text-xs font-medium text-amber-700 bg-amber-50 px-2 py-1 rounded border border-amber-100" data-id="element-5414" data-mp="gql6n8h36y7c">
                      Intervention prévue
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-5415" data-mp="qgwayw4on9er">
                    <div className="flex items-center gap-3" data-id="element-5416" data-mp="vfpsczn3bkk7">
                      <div className="w-8 h-8 rounded-full bg-emerald-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5417" data-mp="vhaimd2dghc9">
                        ST
                      </div>
                      <div data-id="element-5418" data-mp="2kyfvi2ndhgcu">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-5419" data-mp="2kuicri4piqth">
                          Sylvie Tremblay
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5420" data-mp="2azqfkff1e5z8">
                          Réception · Observatrice
                        </div>
                      </div>
                    </div>
                    <button className="text-xs font-medium text-[#4F46E5] hover:text-[#4338CA]" data-id="element-5421" data-mp="33mb6jerlog29">
                      Voir
                    </button>
                  </div>
                </div>
                <button className="mt-4 flex items-center gap-2 text-sm font-medium text-[#4F46E5] hover:text-[#4338CA]" data-id="element-5422" data-mp="2twhukcnjpyxh">
                  <PlusIcon className="w-4 h-4" data-id="element-5423" data-mp="2oy6idv9s3cc3" /> Ajouter un intervenant
                </button>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5424" data-mp="3mfx2ade5w1cp">
                <div className="flex items-center justify-between gap-3 mb-4" data-id="element-5425" data-mp="3hlsx9zogi3e9">
                  <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider" data-id="element-5426" data-mp="1fqwijpzfmluk">
                    NOTES INTERNES
                  </h3>
                  <span className="inline-flex items-center gap-1 text-[11px] font-medium text-slate-400" data-id="element-5427" data-mp="15zs5ivtbhb2d">
                    <LockIcon className="w-3 h-3" data-id="element-5428" data-mp="1aylimn4oz020" />
                    Jamais visible par le citoyen
                  </span>
                </div>
                <div className="space-y-3" data-id="element-5429" data-mp="wxium4u4zfog">
                  <div className="flex gap-3" data-id="element-5430" data-mp="110pb05ayqn8n">
                    <div className="w-7 h-7 rounded-full bg-slate-800 text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" data-id="element-5431" data-mp="111gtcefjuogz">
                      JD
                    </div>
                    <div className="flex-1" data-id="element-5432" data-mp="s0sj7uta189d">
                      <div className="bg-slate-50 rounded-lg p-3 text-sm text-slate-700 border border-slate-200" data-id="element-5433" data-mp="2hexiqtr2qs08">
                        Visite sur place effectuée. Trois branches de bonne
                        taille à tronçonner, la nacelle n'est pas nécessaire.
                        Prévoir deux employés pour l'avant-midi.
                      </div>
                      <div className="text-[11px] text-slate-400 mt-1" data-id="element-5434" data-mp="5t52pegbmyxy">
                        Jacques Dubois · il y a 2 h
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-3" data-id="element-5435" data-mp="fo6ruaalk10j">
                    <div className="w-7 h-7 rounded-full bg-amber-500 text-white flex items-center justify-center text-[10px] font-bold flex-shrink-0" data-id="element-5436" data-mp="tgwkgxkms46m">
                      MG
                    </div>
                    <div className="flex-1" data-id="element-5437" data-mp="13fvtih9b61u5">
                      <div className="bg-slate-50 rounded-lg p-3 text-sm text-slate-700 border border-slate-200" data-id="element-5438" data-mp="13eu75gmudsx4">
                        Le camion nacelle est en réparation jusqu'au 22. On
                        peut quand même y aller au sol comme prévu le 21.
                      </div>
                      <div className="text-[11px] text-slate-400 mt-1" data-id="element-5439" data-mp="30970jf96y5uo">
                        Martin Gauthier · hier, 16:04
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex items-center gap-2" data-id="element-5440" data-mp="2jbgojh5vrhk9">
                  <input type="text" value={noteDraft} onChange={e => setNoteDraft(e.target.value)} placeholder="Ajouter une note interne..." className="flex-1 px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5441" data-mp="2o5kx24usnxng" />
                  <button disabled={!noteDraft.trim()} onClick={() => setNoteDraft('')} className="px-4 py-2 bg-[#0F172A] text-white text-sm font-semibold rounded-lg hover:bg-slate-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-5442" data-mp="25c7bgqcz13ki">
                    Publier
                  </button>
                </div>
              </div>
            </div>}

          {rightTab === 'historique' && <div className="p-6 overflow-y-auto flex-1" data-id="element-5443" data-mp="1563taxh0ftxt">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5444" data-mp="10ebygaqtn21v">
                JOURNAL D'ACTIVITÉ
              </h3>
              <div className="relative border-l-2 border-slate-200 ml-3 space-y-6" data-id="element-5445" data-mp="vfimwnv3hl4c">
                <div className="relative pl-6" data-id="element-5446" data-mp="qi8ztev6hljo">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-[#4F46E5] border-2 border-white" data-id="element-5447" data-mp="lhuptra0o1j0"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5448" data-mp="hf7w1ktsc6j6">
                    Intervention planifiée au 21 mai
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5449" data-mp="cizmqo29r7jx">
                    Martin Gauthier (Parcs et espaces verts)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5450" data-mp="26unyyih48w0m">
                    20 mai 2026 · 16:04
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5451" data-mp="2x2ia66td1a3t">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-[#4F46E5] border-2 border-white" data-id="element-5452" data-mp="2s4p5ji7pgo5n"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5453" data-mp="35wn9zfqh1vvh">
                    Réponse envoyée au citoyen
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5454" data-mp="2e5pgwak7099h">
                    Jacques Dubois (Travaux publics)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5455" data-mp="2987fd58i8wbi">
                    19 mai 2026 · 09:47
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5456" data-mp="2i7khfcuauim7">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-amber-500 border-2 border-white" data-id="element-5457" data-mp="2i6sxx0dz8bca"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5458" data-mp="2ij4whn9z031">
                    Statut changé de « Reçue » à « En cours »
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5459" data-mp="5xau4aliejgs">
                    Jacques Dubois (Travaux publics)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5460" data-mp="9xus1gdwpr3z">
                    19 mai 2026 · 09:30
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5461" data-mp="yhiyotp34js">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-emerald-500 border-2 border-white" data-id="element-5462" data-mp="11dhae9gfv8r"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5463" data-mp="tnooi7rkguej">
                    Requête assignée aux Travaux publics
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5464" data-mp="eys7vmbg292b">
                    Sylvie Tremblay (Réception)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5465" data-mp="17npnfho9trrd">
                    19 mai 2026 · 08:41
                  </div>
                </div>
                <div className="relative pl-6" data-id="element-5466" data-mp="1cg0paq2knnmk">
                  <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-2 border-white" data-id="element-5467" data-mp="1ma6afsqbb1n3"></div>
                  <div className="text-sm font-semibold text-slate-900" data-id="element-5468" data-mp="1hb22t6j1dbyv">
                    Requête déposée avec deux photos
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-5469" data-mp="1ceblygzeqcce">
                    Nathalie Ouellet (Application bciti+)
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5470" data-mp="13btxdvwa57m8">
                    19 mai 2026 · 08:12
                  </div>
                </div>
              </div>
            </div>}

          <div className={`p-6 overflow-y-auto flex-1 space-y-6 ${rightTab === 'gestion' ? '' : 'hidden'}`} data-id="element-5471" data-mp="tkzf12m5ms62">
            <div className="text-sm text-slate-500 font-medium" data-id="element-5472" data-mp="oohbg62k8zvb">
              19 mai <span className="mx-2 text-slate-300" data-id="element-5473" data-mp="kk17wbgf64j9">→</span>{' '}
              <span className="text-red-500" data-id="element-5474" data-mp="fm81pif49aiz">26 mai</span>
            </div>

            {/* Tasks */}
            <div className="space-y-3" data-id="element-5475" data-mp="2r9laqiwjceh0">
              <div className="flex items-start gap-3" data-id="element-5476" data-mp="2r8jorjdze7ki">
                <CheckSquareIcon className="w-5 h-5 text-slate-900 mt-0.5" data-id="element-5477" data-mp="2w8601na91dqo" />
                <div className="flex-1" data-id="element-5478" data-mp="2wa90z2cxwra6">
                  <div className="text-sm text-slate-500 line-through" data-id="element-5479" data-mp="309rkbtp44uaw">
                    Vérifier la disponibilité des équipes
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5480" data-mp="35702hua9gyc5">
                    Terminée: 22 mai 2026{' '}
                    <PencilIcon className="w-3 h-3 inline ml-1" data-id="element-5481" data-mp="2ckf2y6jmtfxi" />
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5482" data-mp="2hjrz5hwe7zcr">
                  <CalendarIcon className="w-3 h-3" data-id="element-5483" data-mp="2hhoym3xm6nts" /> 22 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full bg-indigo-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5484" data-mp="2mcbcqev2yuhk">
                  ML
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-5485" data-mp="1truohu4ojdd8">
                <SquareIcon className="w-5 h-5 text-slate-300 mt-0.5" data-id="element-5486" data-mp="af5mrvvznxs" />
                <div className="flex-1" data-id="element-5487" data-mp="3rhrr3j3synji">
                  <div className="text-sm text-slate-700" data-id="element-5488" data-mp="3rit1rmgwp80p">
                    Planifier le ramassage des branches
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5489" data-mp="4d23b9f8o32w">
                  <CalendarIcon className="w-3 h-3" data-id="element-5490" data-mp="4az4bzw3yzm1" /> 25 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5491" data-mp="j3sviikqt46j">
                  ST
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-5492" data-mp="s0a9ruoeli6i">
                <SquareIcon className="w-5 h-5 text-slate-300 mt-0.5" data-id="element-5493" data-mp="o0j8uy55xlo9" />
                <div className="flex-1" data-id="element-5494" data-mp="2tthnx0sa5tqt">
                  <div className="text-sm text-slate-700" data-id="element-5495" data-mp="2tuj0xasuwqb6">
                    Contacter le demandeur pour suivi
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5496" data-mp="2fohcv9dsfj3i">
                  <CalendarIcon className="w-3 h-3" data-id="element-5497" data-mp="2fqlflnzyac27" /> 20 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full border border-dashed border-slate-300 text-slate-400 flex items-center justify-center text-[10px]" data-id="element-5498" data-mp="2jrx6dwuk93bz">
                  <UserIcon className="w-3 h-3" data-id="element-5499" data-mp="2awpj6pzc4x95" />
                </div>
              </div>
              <button className="text-sm text-slate-500 font-medium flex items-center gap-1 hover:text-slate-700 mt-2" data-id="element-5500" data-mp="1vzqd56k4tcgs">
                <PlusIcon className="w-4 h-4" data-id="element-5501" data-mp="2104ds3jelk4s" /> Ajouter une tâche
              </button>
            </div>

            {/* Linked Requests */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5502" data-mp="1n1wkq6phn2yw">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5503" data-mp="1rywtipdq2jtp">
                REQUÊTES LIÉES
              </h3>
              <div className="space-y-3" data-id="element-5504" data-mp="3mcea1sfpmgf8">
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5505" data-mp="3mc5u1roaiuzt">
                  <div className="flex items-center gap-3" data-id="element-5506" data-mp="3fw5yjhe1jm07">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5507" data-mp="3fys4jcla9tgb">
                      Liée ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5508" data-mp="360cdtaq64m7c">
                      R-68 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5509" data-mp="2i17sqpi5y0e">
                      Lampadaire défectueux
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('En Attente')}`} data-id="element-5510" data-mp="3oxly0u3bi3pn">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('En Attente')}`} data-id="element-5511" data-mp="lgdkunjjbs19"></div>
                    En Attente
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5512" data-mp="xq379zry9ac5">
                  <div className="flex items-center gap-3" data-id="element-5513" data-mp="12s293581jz6z">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5514" data-mp="17pk92642z42u">
                      Bloque ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5515" data-mp="1gofhloulkq9b">
                      R-72 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5516" data-mp="1qfjumj0pq11i">
                      Nid-de-poule rue Principale
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('Reçue')}`} data-id="element-5517" data-mp="1vcjzwrpqmzrk">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('Reçue')}`} data-id="element-5518" data-mp="2kp3sw1hgtqds"></div>
                    Reçue
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5519" data-mp="2uobf7e66gvd1">
                  <div className="flex items-center gap-3" data-id="element-5520" data-mp="221gwalp0e41o">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5521" data-mp="1x1m8ir0j5uku">
                      Doublon ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5522" data-mp="26zii3edtkhgu">
                      R-75 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5523" data-mp="1j7ux1d38o0mh">
                      Banc de parc endommagé
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('En Cours')}`} data-id="element-5524" data-mp="3px5a9y2825f2">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('En Cours')}`} data-id="element-5525" data-mp="3gy1qerv8dlzi"></div>
                    En Cours
                  </div>
                </div>
              </div>
              <button className="text-sm text-slate-500 font-medium flex items-center gap-1 hover:text-slate-700 mt-3" data-id="element-5526" data-mp="cklcwto9hubj">
                <PlusIcon className="w-4 h-4" data-id="element-5527" data-mp="hgaj3fuse9gt" /> Lier une requête
              </button>
            </div>

            {/* Tags */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5528" data-mp="8hgep3b7sesp">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5529" data-mp="8jjeug62zob5">
                ÉTIQUETTES
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-5530" data-mp="2t87fifuh27hw">
                <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-medium border border-indigo-100 flex items-center gap-1" data-id="element-5531" data-mp="2t5uozeaneot8">
                  Urgent <XIcon className="w-3 h-3 cursor-pointer" data-id="element-5532" data-mp="2hspf96chnap6" />
                </span>
                <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-medium border border-indigo-100 flex items-center gap-1" data-id="element-5533" data-mp="233symkwd8pcy">
                  Suivi requis <XIcon className="w-3 h-3 cursor-pointer" data-id="element-5534" data-mp="2vrp002wvr5g2" />
                </span>
                <button className="px-3 py-1 rounded-full border border-dashed border-slate-300 text-slate-500 text-xs font-medium flex items-center gap-1 hover:border-slate-400 hover:text-slate-700 transition-colors" data-id="element-5535" data-mp="2vpuh0u565nem">
                  <PlusIcon className="w-3 h-3" data-id="element-5536" data-mp="2qsc6izbi704i" /> Ajouter une étiquette
                </button>
              </div>
            </div>

            {/* Internal Files */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5537" data-mp="1agglf1c3htwb">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5538" data-mp="1ff09p8e5vhru">
                FICHIERS INTERNES
              </h3>
              <div className="flex gap-3" data-id="element-5539" data-mp="3omdfv5iriwvu">
                <div className="w-20 rounded-lg border border-slate-200 p-2 flex flex-col items-center justify-center text-center" data-id="element-5540" data-mp="3olbsq2oh2jxr">
                  <FileTextIcon className="w-8 h-8 text-red-500 mb-2" data-id="element-5541" data-mp="6e5v9r9vs2pg" />
                  <div className="text-[10px] font-medium text-slate-700 truncate w-full" data-id="element-5542" data-mp="2few7eluuazp">
                    rapport_inspe...
                  </div>
                  <div className="text-[9px] text-slate-400" data-id="element-5543" data-mp="35vvr1c11wlfr">22 mai</div>
                </div>
                <div className="w-20 h-24 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5544" data-mp="3jms4twqbiy2r">
                  <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=200&h=200&fit=crop" alt="Doc" className="w-full h-full object-cover" data-id="element-5545" data-mp="3jov7bg8nqjod" />
                </div>
                <div className="w-20 h-24 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5546" data-mp="2n4ckwwbqcr9i">
                  <img src="https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=200&h=200&fit=crop" alt="Doc" className="w-full h-full object-cover" data-id="element-5547" data-mp="q3gmmq5kxybb" />
                </div>
                <button className="w-20 h-24 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" data-id="element-5548" data-mp="14tebl8bc2s1k">
                  <PlusIcon className="w-5 h-5 mb-1" data-id="element-5549" data-mp="c4759n5n0y5r" />
                  <span className="text-xs font-medium" data-id="element-5550" data-mp="c6tc1kkpf9mx">Téléverser</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-5551" data-mp="m47t9megc2ga">
      {/* Header */}
      <div className="p-4 border-b border-slate-200" data-id="element-5552" data-mp="1sl33ink8tehz">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-5553" data-mp="1xh0hwoby4as4">
          <div className="flex items-center gap-3" data-id="element-5554" data-mp="3hz2lgh9xohex">
            <div className="inline-flex items-center bg-slate-100 rounded-lg p-1 gap-1" data-id="element-5555" data-mp="3i1x4c4datu68">
              <button onClick={() => setViewMode('list')} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${viewMode === 'list' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5556" data-mp="3d342583gppld">
                <TableIcon className="w-4 h-4" data-id="element-5557" data-mp="2y9s839xnu8jz" />
                Tableau
              </button>
              <button onClick={() => setViewMode('map')} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${viewMode === 'map' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5558" data-mp="2ucw4h5ij7rck">
                <MapIcon className="w-4 h-4" data-id="element-5559" data-mp="nhpjugnmc2r3" />
                Carte
              </button>
            </div>
            <span className="text-sm text-slate-500" data-id="element-5560" data-mp="3ccysyahtllmq">10 demandes</span>
          </div>

          <div className="flex items-center gap-3" data-id="element-5561" data-mp="3cb4bx79o6dnx">
            <div className="relative" data-id="element-5562" data-mp="3gd90vsp6am48">
              <SearchIcon className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-5563" data-mp="3gc7pfn48vxlz" />
              <input type="text" placeholder="Rechercher des requêtes..." className="pl-9 pr-4 py-2 border border-slate-200 rounded-lg text-sm w-64 focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5564" data-mp="32h5883ty6ltv" />
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm font-semibold rounded-lg hover:bg-slate-50 transition-colors" data-id="element-5565" data-mp="2jo9tefwexod3">
              <FilterIcon className="w-4 h-4" data-id="element-5566" data-mp="2ol06qvgu25ut" />
              Filtrer
            </button>
            <button onClick={() => setShowCreate(true)} className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors whitespace-nowrap" data-id="element-5567" data-mp="29s6q36ptrjok">
              <PlusIcon className="w-4 h-4" data-id="element-5568" data-mp="1r2uwsyfcdbic" />
              Créer une requête
            </button>
          </div>
        </div>
      </div>

      {/* Map View */}
      {viewMode === 'map' && <div className="h-[400px] w-full border-b border-slate-200" data-id="element-5569" data-mp="202869r3gu032">
          <MapContainer center={[45.4499, -73.4653]} zoom={13} scrollWheelZoom={false} style={{
        height: '100%',
        width: '100%'
      }} data-id="element-5570" data-mp="2e297x8rk1bjl">
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-5571" data-mp="2nsc23caewvji" />
            {MAP_MARKERS.map(m => <Marker key={m.reqId} position={m.position} icon={requestMarkerIcon} data-id="element-5572" data-mp="2xnvsxka4d41e">
                <Popup data-id="element-5573" data-mp="2zv4xqahegs0o">
                  <div className="text-sm" data-id="element-5574" data-mp="2zvy7lkbnnxn1">
                    <div className="font-semibold text-slate-900" data-id="element-5575" data-mp="34t6q5m0pu3ot">
                      {m.reqId} — {m.subject}
                    </div>
                    <div className="text-slate-500" data-id="element-5576" data-mp="39rrean2p0www">{m.category}</div>
                  </div>
                </Popup>
              </Marker>)}
          </MapContainer>
        </div>}

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-5577" data-mp="3jht71s5zr3i5">
        <table className="w-full text-left border-collapse" data-id="element-5578" data-mp="3njo3ojcz8spl">
          <thead data-id="element-5579" data-mp="3ni4nstv8gjoc">
            <tr className="border-b border-slate-200 bg-white" data-id="element-5580" data-mp="3nlsivxgbte56">
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5581" data-mp="3sjk82jpl6m5o">
                <span className="inline-flex items-center gap-1" data-id="element-5582" data-mp="1beo1esv83cw">
                  Sujet{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5583" data-mp="1y6b57arjpywe" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5584" data-mp="234co9voz1y7v">
                <span className="inline-flex items-center gap-1" data-id="element-5585" data-mp="1vlwdgg59tipv">
                  Catégorie{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5586" data-mp="1qsk41d95xihp" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5587" data-mp="1lsfih8tedxkm">
                <span className="inline-flex items-center gap-1" data-id="element-5588" data-mp="1gtuhv8a8hbvn">
                  ID Requête{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5589" data-mp="2eh397jwx1f5k" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5590" data-mp="24kzz9rvtoc82">
                Emplacement
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5591" data-mp="1zldnlmvn741d">
                <span className="inline-flex items-center gap-1" data-id="element-5592" data-mp="t6w4ijheuk1y">
                  Date de création{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5593" data-mp="o5gl0vuvsllo" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5594" data-mp="1dx8hqz1d9qkq">
                <span className="inline-flex items-center gap-1" data-id="element-5595" data-mp="1is5lprjsh9qr">
                  Statut{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5596" data-mp="14wk1dxoi3e4o" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5597" data-mp="1wln61ekauqhu">
                <span className="inline-flex items-center gap-1" data-id="element-5598" data-mp="1wnzodstyz2vf">
                  Département{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5599" data-mp="1ntbh5x4u3b3z" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5600" data-mp="1ruevugb5b13m">
                Demandeur
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5601" data-mp="2fiy5p09uflxt">
                Date SLA
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5602" data-mp="8vgypthk9zcp">
            {MOCK_REQUESTS.map(req => <tr key={req.id} onClick={() => setSelectedRequest(req)} className="hover:bg-slate-50 cursor-pointer transition-colors" data-id="element-5603" data-mp="3xxiio1azci4">
                <td className="px-4 py-3 text-sm text-slate-700 whitespace-nowrap" data-id="element-5604" data-mp="dmpbmzi3o2um">
                  <div className="flex items-center gap-2" data-id="element-5605" data-mp="3m28zfj004t2a">
                    <div className="w-8 h-8 rounded bg-slate-50 border border-slate-200 flex items-center justify-center" data-id="element-5606" data-mp="3m4v6zimw78ki">
                      <FolderIcon className="w-4 h-4 text-[#4F46E5]" data-id="element-5607" data-mp="3w0orbo6us6cu" />
                    </div>
                    {req.subject}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5608" data-mp="3r3ycf46sbgt0">
                  {req.category}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5609" data-mp="16c5zrkyosxl1">
                  {req.reqId}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5610" data-mp="1kzsd0j32wuro">
                  <div className="flex items-center gap-1" data-id="element-5611" data-mp="1fy2y2scqjwyb">
                    {req.location}
                    <MapPinIcon className="w-3 h-3 text-[#4F46E5]" data-id="element-5612" data-mp="1b12s0hfvyu77" />
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5613" data-mp="16zra6y397d9k">
                  {req.date}
                </td>
                <td className="px-4 py-3 whitespace-nowrap" data-id="element-5614" data-mp="23qjj9brrs51u">
                  <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(req.status)}`} data-id="element-5615" data-mp="1yqx3aukk4apc">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot(req.status)}`} data-id="element-5616" data-mp="1pw91jee6xb5a"></div>
                    {req.status}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5617" data-mp="2hmx0cjse64fs">
                  {req.department}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5618" data-mp="94x32gf0k1c8">
                  <div className="flex items-center gap-2" data-id="element-5619" data-mp="9716yycwx0ci">
                    <div className={`w-6 h-6 rounded-full ${req.requester.color} text-white flex items-center justify-center text-[10px] font-bold`} data-id="element-5620" data-mp="d5h3bsuvvl2l">
                      {req.requester.initials}
                    </div>
                    {req.requester.name}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5621" data-mp="wuhnl3qtf6nm">
                  {req.slaDate}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="p-4 border-t border-slate-200 flex items-center justify-end gap-6 text-sm text-slate-500" data-id="element-5622" data-mp="15vz3al0b96bs">
        <div className="flex items-center gap-2" data-id="element-5623" data-mp="1av28q6k7deka">
          Éléments par page
          <select className="border-b border-slate-300 pb-1 focus:outline-none bg-transparent font-medium text-slate-700" data-id="element-5624" data-mp="36wnhxq23j9pw">
            <option data-id="element-5625" data-mp="31zncnhd2mazu">10</option>
            <option data-id="element-5626" data-mp="31whjnr1bmoyu">20</option>
            <option data-id="element-5627" data-mp="3gnqhgnfdngn2">50</option>
          </select>
        </div>
        <div data-id="element-5628" data-mp="3gpbcsf9in3lz">1 - 10 / 98</div>
        <div className="flex items-center gap-4" data-id="element-5629" data-mp="3bwrxndv6k0f2">
          <button className="hover:text-slate-900" data-id="element-5630" data-mp="3bux9lqom3s6r">
            <ChevronLeftIcon className="w-4 h-4" data-id="element-5631" data-mp="3pndiv983wmg4" />
          </button>
          <button className="hover:text-slate-900" data-id="element-5632" data-mp="3pprcrer1vsm3">
            <ChevronRightIcon className="w-4 h-4" data-id="element-5633" data-mp="3ll9wvqnt9zgl" />
          </button>
        </div>
      </div>

      {showCreate && <CreateRequeteDialog onClose={() => setShowCreate(false)} data-id="element-5634" data-mp="3g6o9vymz5bf" />}
    </div>;
}
// Missing icons for the component
function CalendarIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5635" data-mp="258la364awtx4">
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" data-id="element-5636" data-mp="kqkcmowtiovb" />
      <line x1="16" x2="16" y1="2" y2="6" data-id="element-5637" data-mp="krvdogyvpiiq" />
      <line x1="8" x2="8" y1="2" y2="6" data-id="element-5638" data-mp="61wgohj28d4u" />
      <line x1="3" x2="21" y1="10" y2="10" data-id="element-5639" data-mp="5z1xetbs8yd0" />
    </svg>;
}
function UserIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5640" data-mp="3t63yv3z2n70v">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-5641" data-mp="3j9heshekkjzw" />
      <circle cx="12" cy="7" r="4" data-id="element-5642" data-mp="3o5y3bcpol0di" />
    </svg>;
}
function PencilIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5643" data-mp="1hhl4fb451g6p">
      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" data-id="element-5644" data-mp="3eh78x4agxn42" />
      <path d="m15 5 4 4" data-id="element-5645" data-mp="3eetcos41y4ux" />
    </svg>;
}